import React, { useState, useEffect, lazy, Suspense } from 'react';
import { params, shape, string as stringType } from '@thd-nucleus/data-sources';
import axios from 'axios';
import { localize } from './utils/setupLocalization';
import { setAdditionalPageInfo } from './utils/analytics/digitalDataBuilder';
import { injectedConfiguratorSettings } from './config';

const DeckingConfiguratorLazy = lazy(() => import(
  /* webpackChunkName: "decking-configurator-lazy" */
  './modules/decking-configurator/apps/configurator/index'
).then((mod) => {
  return {
    default: (props) => {
      const { DeckingConfigurator: DeckingConfiguratorComp } = mod;
      return (
        <DeckingConfiguratorComp {...props} />
      );
    }
  };
}));

const ProductConfiguratorLazy = lazy(() => import(
  /* webpackChunkName: "product-configurator-lazy" */
  './components/ProductConfiguratorWrapper'
).then((mod) => {
  return {
    default: (props) => {
      const { ProductConfiguratorWrapper: ProductConfiguratorWrapperComp } = mod;
      return (
        <ProductConfiguratorWrapperComp {...props} />
      );
    }
  };
}));

const configurator = (props) => {
  const [isClientReady, setClientReady] = useState(false);
  const [productType, setProductType] = useState('');
  const lumberProductTypes = ['Composite Decking Boards','Fascia Boards'];

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const configuratorSettings = injectedConfiguratorSettings(props.itemId);
    axios.get(
      configuratorSettings.pipfiguratorQuickLookupUrl,
      { cancelToken: source.token }
    )
    .then(function (response) {
      const prodType = response?.data?.ProductType
      setProductType(prodType);
      setClientReady(true);
      const productInfo = {
        sku: response?.data?.ProductId,
        productName: response?.data?.ProductName,
        productType: response?.data?.ProductType,
      };
      setAdditionalPageInfo('item', productInfo);
    })
    .catch(function (error) {
      if (axios.isCancel(error)) {
        console.log('upfront call error=>', error);
      }
      setClientReady(false);
    });

    return () => {
      source.cancel();
    }
  }, [props.itemId]);

  if (!isClientReady || !productType) { return null; }

  localize();

  if (productType && lumberProductTypes.includes(productType.trim())) {
    return (
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <DeckingConfiguratorLazy />
        </Suspense>
      </div>
    )
  }
  else {
    return (
      <div>
        <Suspense fallback={<div style={{minHeight: '300px', display: 'block'}}>Loading...</div>}>
          <ProductConfiguratorLazy {...props} />
        </Suspense>
      </div>
    )
  }
}

configurator.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSource: stringType(),
    identifiers: shape({
      productLabel: stringType()
    })
  })
};

export { configurator as ProductConfigurator };
